export default __webpack_public_path__ + "static/media/illus_2FA_5.d06b7205.svg";